/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCreateCustomListDto
 */
export interface WebApiCustomListsDtoCreateCustomListDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCreateCustomListDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateCustomListDto
     */
    listType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCreateCustomListDto
     */
    createdBy?: number | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCreateCustomListDto interface.
 */
export function instanceOfWebApiCustomListsDtoCreateCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCreateCustomListDtoFromJSON(json: any): WebApiCustomListsDtoCreateCustomListDto {
    return WebApiCustomListsDtoCreateCustomListDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCreateCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCreateCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'listType': !exists(json, 'listType') ? undefined : json['listType'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
    };
}

export function WebApiCustomListsDtoCreateCustomListDtoToJSON(value?: WebApiCustomListsDtoCreateCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'listType': value.listType,
        'createdBy': value.createdBy,
    };
}

